import { InterleavedBuffer, InterleavedBufferAttribute } from "three";
export function setInterleavedBufferAttributes(geometry, vertices, totalSize, names, sizes) {
    var buffer = new InterleavedBuffer(new Float32Array(vertices), totalSize);
    var offset = 0;
    var len = names.length;
    for (var i = 0; i < len; i++) {
        var size = sizes[i];
        geometry.setAttribute(names[i], new InterleavedBufferAttribute(buffer, size, offset));
        offset += size;
    }
}
